module.exports = __webpack_public_path__ + "static/media/logo.79fbbdb2.png";